// A non-secret preference only. Credentials are held separately in the vault.
const KEY = "redacted-v2-private-session-intent";

export const readPrivateSessionIntent = (): boolean => {
  try {
    return sessionStorage.getItem(KEY) === "private";
  } catch {
    return false;
  }
};

export const writePrivateSessionIntent = (value: boolean): void => {
  try {
    if (value) sessionStorage.setItem(KEY, "private");
    else sessionStorage.removeItem(KEY);
  } catch {
    /* Restricted browsers retain the in-memory session only. */
  }
};
